module.exports = __webpack_public_path__ + "static/img/unauthorised.23ac6d1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/illustrations/unauthorised.svg
// module id = NJOa
// module chunks = 3